import { GTMAccommodationItem } from "@/helpers/gtm/GTMAccommodationItem.ts";
import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { RateGroup, RatePlan } from "@/helpers/types/types.ts";
import TagManager from "react-gtm-module";

// Tracks whenever user clicks anywhere in the single accommodation card
export const handleGTMAddAccommodationToCart = (RP: RatePlan, RG: RateGroup) => {
  const selecteditem: GTMAccommodationItem = {
    item_id: RP.id,
    item_name: RP.name,
    currency: "EUR",
    price: RP.defaultPriceBreakdown.withDiscount,
    item_category: RG.name,
    index: 0,
    quantity: 1,
  };

  TagManager.dataLayer({
    dataLayer: {
      event: GTMEvent.AddToCart,
      ecommerce: {
        currency: "EUR",
        value: RP.defaultPriceBreakdown.withDiscount,
        items: [selecteditem],
      },
    },
  });
};
